import React, { useEffect, useState, useMemo } from 'react';
import AdyenCheckout from '@adyen/adyen-web';
import isEmpty from 'lodash/isEmpty';
import Tabs from 'components/Tabs/Tabs';
import { getTemplateString } from 'common/helpers/string';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import Tooltip from 'components/Tooltip/Tooltip';
import http from 'app/http';
import qs from 'qs';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'app/hooks';
import { setContent } from 'features/content/reducer';
import PageLink from 'components/PageLink/PageLink';
import styles from './TabPayment.module.scss';
import { getPaymentConfig } from 'common/helpers/payments';
import { UrlEncodedHeaders } from 'features/payment/services';
import { formProgression } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
}

const TabPayment = ({ PageData, Model }: Props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [
    changedSelectedPaymentMethodType,
    setchangedSelectedPaymentMethodType,
  ] = useState<string>('');
  const [canApplePay, setCanApplePay] = useState<boolean>(false);
  const [canGooglePay, setCanGooglePay] = useState<boolean>(false);
  const paymentConfig = useMemo(() => getPaymentConfig(Model), [Model]);

  const [validateModel, setvalidateModel] = useState(false);
  const [isManualPayment, setIsManualPayment] = useState<boolean>(false);
  const imgsrc = getTemplateString('/images/icons/payment/{itemType}.png');
  const [checkoutObj, SetcheckoutObj] = useState<any>(null);

  const assignManualHeadAndToolTip = () => {
    if (
      !isNullOrWhiteSpace(PageData?.AutomatedPaymentTooltipInformation) ||
      !isNullOrWhiteSpace(PageData?.ManualPaymentTooltipInformation)
    ) {
      return (
        <div className={styles.displayflex}>
          {PageData?.ManualTabLabel}
          <Tooltip id="PaymentTooltipInformationTooltip">
            <strong>{PageData?.AutomatedPaymentTooltipHeader}</strong>
            {PageData?.AutomatedPaymentTooltipInformation}

            <strong>{PageData?.ManualPaymentTooltipHeader}</strong>
            {PageData?.ManualPaymentTooltipInformation}
          </Tooltip>
        </div>
      );
    }
  };

  const tabsLabels = useMemo(() => {
    const labels = [];
    if (!isEmpty(Model?.AutomatedPaymentMethods)) {
      labels.push(PageData?.AutomatedTabLabel);
    }
    if (!isEmpty(Model?.ManualPaymentMethods)) {
      labels.push(assignManualHeadAndToolTip());
    }
    return labels;
  }, [Model?.AutomatedPaymentMethods, Model?.ManualPaymentMethods]);

  function changePaymentMethodType(e: any, isManual: boolean) {
    setchangedSelectedPaymentMethodType(e.target.value);
    setIsManualPayment(isManual);
  }
  useEffect(() => {
    if (Model.ManualPaymentMethods.length > 0 && isNullOrWhiteSpace(changedSelectedPaymentMethodType)) {
      setchangedSelectedPaymentMethodType(Model.FormModel.SelectedPaymentMethodType);
    }
  }, [changedSelectedPaymentMethodType])
  async function adyenDropinCheckout
    (config: any) {
    try {
      if (checkoutObj == null) {
        let resCheckout = await AdyenCheckout(config).then((response) => { return response });
        SetcheckoutObj(resCheckout);

        if (resCheckout) {
          const googlepay = resCheckout.create('paywithgoogle');

          googlepay
            .isAvailable()
            .then(() => {
              setCanGooglePay(true);
            })
            .catch(() => {
              setCanGooglePay(false);
            });

          const applepay = resCheckout.create('applepay');

          applepay
            .isAvailable()
            .then(() => {
              setCanApplePay(true);
            })
            .catch(() => {
              setCanApplePay(false);
            });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    adyenDropinCheckout(paymentConfig);
  }, [paymentConfig, Model]);

  const automatedPaymentMethod = Model.AutomatedPaymentMethods.map(
    (AutomatedPaymentMethod: {
      ElementId: any;
      Type: any;
      Selected: any;
      CssClass: any;
      Name: any;
    }) => {
      const itemImageSrc =
        imgsrc &&
        `${process.env.PUBLIC_URL}${imgsrc({
          itemType: AutomatedPaymentMethod.Type,
        })}`;
      if (
        (AutomatedPaymentMethod.Type === 'paywithgoogle' && !canGooglePay) ||
        (AutomatedPaymentMethod.Type === 'applepay' && !canApplePay)
      ) {
        return null;
      }
      return (
        <label
          id={'wrap_' + AutomatedPaymentMethod.ElementId}
          key={AutomatedPaymentMethod.ElementId}
          className="paymentOptions__label"
        >
          <input
            type="radio"
            name={Model.FormModel.SelectedPaymentMethodType}
            id={AutomatedPaymentMethod.ElementId}
            value={AutomatedPaymentMethod.Type}
            checked={
              AutomatedPaymentMethod.Type === changedSelectedPaymentMethodType
            }
            className={styles.paymentinput}
            onChange={(e) => changePaymentMethodType(e,false)}
            onBlur={(e)=>formProgression(e,'UpdatePlanChangePaymentTypeForm','selectedPaymentMethod')}
          />
          <span className={styles.customInput}>
            <img
              src={itemImageSrc}
              className={AutomatedPaymentMethod.CssClass}
            />
          </span>
          {AutomatedPaymentMethod.Name}
        </label>
      );
    },
  );

  const manualPaymentMethod = Model.ManualPaymentMethods.map(
    (ManualPaymentMethod: {
      ElementId: any;
      Type: any;
      Selected: any;
      CssClass: any;
      Name: any;
    }) => {
      const itemImageSrc =
        imgsrc &&
        `${process.env.PUBLIC_URL}${imgsrc({
          itemType: ManualPaymentMethod.Type,
        })}`;
      if (
        (ManualPaymentMethod.Type === 'manualpaywithgoogle' && !canGooglePay) ||
        (ManualPaymentMethod.Type === 'manualApplePay' && !canApplePay)
      ) {
        return null;
      }
      return (
        <label
          id={'wrap_' + ManualPaymentMethod.ElementId}
          key={ManualPaymentMethod.ElementId}
          className="paymentOptions__label"
        >
          <input
            type="radio"
            name={Model.FormModel.SelectedPaymentMethodType}
            id={ManualPaymentMethod.ElementId}
            value={ManualPaymentMethod.Type}
            checked={
              ManualPaymentMethod.Type == changedSelectedPaymentMethodType
            }
            className={styles.paymentinput}
            onChange={(e) => changePaymentMethodType(e,true)}
            onBlur={(e)=>formProgression(e,'UpdatePlanChangePaymentTypeForm','selectedPaymentMethod')}
          />
          <span className={styles.customInput}>
            <img src={itemImageSrc} className={ManualPaymentMethod.CssClass} />
          </span>
          {ManualPaymentMethod.Name}
        </label>
      );
    },
  );

  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };
  const formSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const confirmURL = getPathnameFromUrl(
        Model?.ConfirmPaymentMethodPageUrl,
      );
      const response = await http.post(
        confirmURL,
        qs.stringify({
          'FormModel.SelectedPaymentMethodType':
            changedSelectedPaymentMethodType,
        }),
        UrlEncodedHeaders,
      );

      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state

        let nextPagePath = '';
        if (!response.data.RedirectUrl) {
          nextPagePath = confirmURL;
          dispatch(setContent({ [nextPagePath]: response.data }));
          history.push(nextPagePath, {
            noRefresh: true,
          });
          return;
        } else {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
          history.push(nextPagePath, {
            noRefresh: false,
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <form onSubmit={formSubmit}>
      <section className="CreateRepaymentPlan__section">
        <div className="Tabs tabsPayment">
          <div>

            {
              <div className="paymentOptions">
                <h5 className="paymentOptions__heading">
                  {PageData?.MethodsHeading}
                </h5>
                <div className="paymentOptions__wrapper">
                  {automatedPaymentMethod}
                  {manualPaymentMethod}
                </div>

                {isManualPayment && (
                  <div className={styles.manual_error}>
                    <h3 className={styles.heading}>{PageData?.ManualPaymentInfoHeader}</h3>
                    <p className={styles.text}>{PageData?.ManualPaymentInfoText}</p>
                  </div>
                )
                }
              </div>
            }
          </div>
          {Model.FormModel.ShowInvalidPaymentMethodError && (
            <section className="CreateRepaymentPlan__section">
              <span className="text-danger">
                {Model.PageDataBase.InvalidPaymentMethodErrorMessage}
              </span>
            </section>
          )}
        </div>
      </section>

      <section className="CreateRepaymentPlan__section">
        <div className="CreateRepaymentPlan__ctaWrapper">
          <PageLink
            url={Model.BackButtonUrl}
            text={PageData.BackBtnLabel}
            className="Button Button--gray CreateRepaymentPlan__cancelBtn"
          />
          <button
            type="submit"
            className="Button CreateRepaymentPlan__confirmBtn"
          >
            {PageData.NextBtnLabel}
          </button>
        </div>
      </section>
    </form>
  );
};

export default TabPayment;
